import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import {  getProjects } from '../../routes/UserAction';

import { domainUrl, domain, timeFormat, reduceText } from '../../data/dummyData';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function Projects() {
    const dispatch = useDispatch();

    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 3,
        // navText: [
        //     "<i class='bi bi-arrow-left custom-arrow'></i>",
        //     "<i class='bi bi-arrow-right custom-arrow'></i>",
        // ], 
        
    };


    const [projects, setProjects] = useState([]);

    // const fetchProjects = () => {
    //     dispatch(getProjects())
    //     .then(response =>{
    //         let resData = response?.payload?.data;
    //         const editableData = resData?.map(o => ({ ...o }));
    //         setProjects(editableData);
    //     })
    //     .catch((error) => {
    //         console.log(error)
    //     })
    // }

    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        total: 0,
    });

    const fetchProjects = (page = 1) => {
        dispatch(getProjects({ page }))
        .then(response => {
            const resData = response?.payload;
            const isPaginated = !!resData?.meta;

            setProjects(resData.data);
            setPagination(resData.meta);
        })
        .catch(console.log);
    };

    const handlePageChange = (newPage) => {
        if (newPage !== pagination.current_page) {
            fetchProjects(newPage);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, [])


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'project'}/>

        
        {/* <!-- Blog Start --> */}
        <div className="container-fluid blog py-5">
            <div className="container py-5">
                <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                    {/* <h4 className="text-primary">  Our Blogs</h4> */}
                    <h4 className="" style={{color: 'gold'}}> EmyProjects </h4>
                    <h1 className="display-4 mb-4">Our Projects</h1>
                    {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                    </p> */}
                </div>

                <OwlCarousel
                    className="blog-carousel owl-carousel"
                    {...options3}
                >
                {/* <div className="blog-carousel owl-carousel"> */}
                    {projects?.filter(el => el.type == 1)?.length ? projects.filter(el => el.type == 1).map((row) => (
                        <div className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt=""/>
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                {/* <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4"> */}
                                <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                    {/* <div className="small"> <span className='text-primary mr-2'> <i className="bi bi-eye-fill text-primary"></i> {row?.views? row.views.length: 0}</span><span className='text-primary'> <i className="bi bi-heart-fill text-primary"></i> {row?.likes? row.likes.length: 0}</span></div> */}
                                    <div className="small text-primary"><span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}</div>
                                </div>
                                <a href="#" className="h4 d-inline-block mb-3">{row.name? row.name: ''}</a>
                                <p className="mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>
                                {/* <Link to={row.uuid? `/project?id=${row.uuid}`:'/'} className="btn btn-dark py-2 px-4 ms-2"> <span className="me-2">Read More</span>  <i className="fa fa-arrow-right"></i></Link> */}
                            </div>
                        </div>
                    )) : <></>}
                    
                {/* </div> */}
                </OwlCarousel>

                {pagination.last_page > 1 && (
                    <div className="text-center mt-4">
                        {[...Array(pagination.last_page)].map((_, i) => (
                            <button
                                key={i}
                                onClick={() => handlePageChange(i + 1)}
                                className={`btn ${pagination.current_page === i + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
        {/* <!-- Blog End --> */}

        <Footer/>
        </>
    );
}
